import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import dayjs, { Dayjs } from "utils/dayjs"
import { Guid, IApiLink } from "@/types"
import AmountWithCurrency, { IAmountWithCurrencyDto } from "./AmountWithCurrency"

export enum InvoiceCategoryType {
    investment = "investment",
    sdc = "sdc",
    invNotEvaluated = "invNotEvaluated",
}

export interface IGetAssetInvoiceIncomingDto {
    id: Guid
    invoiceDate: string
    invoiceNumber: string
    invoiceType: InvoiceCategoryType
    assignedAmount: IAmountWithCurrencyDto
    assignedForeignCurrencyAmount?: IAmountWithCurrencyDto
    costCategory: string
    ledgerAccount?: string
    referenceText?: string
    links?: IApiLink[]
}

export default class AssetInvoiceIncoming {
    id: Guid
    invoiceDate: Dayjs
    invoiceNumber: string
    invoiceType: InvoiceCategoryType
    assignedAmount: AmountWithCurrency
    assignedForeignCurrencyAmount?: AmountWithCurrency
    costCategory: string
    ledgerAccount?: string
    referenceText?: string

    linkGetInvoiceDetails?: IApiLink

    constructor(dto: IGetAssetInvoiceIncomingDto) {
        this.id = dto.id
        this.invoiceDate = dayjs(dto.invoiceDate, "YYYY-MM-DD") // take only date ignoring the time
        this.invoiceNumber = dto.invoiceNumber
        this.invoiceType = dto.invoiceType
        this.assignedAmount = new AmountWithCurrency(dto.assignedAmount)
        this.assignedForeignCurrencyAmount = dto.assignedForeignCurrencyAmount ? new AmountWithCurrency(dto.assignedForeignCurrencyAmount) : undefined
        this.costCategory = dto.costCategory
        this.ledgerAccount = dto.ledgerAccount
        this.referenceText = dto.referenceText

        this.linkGetInvoiceDetails = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.invoiceDetails && lnk.rel === ApiLinkRel.self)
    }
}
